import { PropsWithChildren, createContext, useContext, useState } from "react";

import axios, { AxiosHeaders, AxiosInstance } from "axios";

type ContextType = {
  isLoggedIn: boolean;
  apiClient: AxiosInstance;
  login: (authToken: string) => void;
};

const Context = createContext<ContextType | null>(null);

export default function useAPI() {
  const ctx = useContext(Context);
  if (!ctx) throw new Error("Missing APIProvider");
  return ctx;
}

const AUTH_STORAGE_KEY = "devAuthStorage";

type ProviderProps = PropsWithChildren<{
  baseURL: string;
  userId: number;
  configureMocks?: (instance: AxiosInstance) => AxiosInstance;
}>;
export function APIProvider({
  baseURL,
  userId,
  configureMocks = (instance) => instance,
  children,
}: ProviderProps) {
  const authToken = localStorage.getItem(AUTH_STORAGE_KEY);
  const [isLoggedIn, setIsLoggedIn] = useState(!!authToken);

  const apiClient = configureMocks(
    axios.create(configAxios({ baseURL, userId, authToken }))
  );

  function login(token: string) {
    localStorage.setItem(AUTH_STORAGE_KEY, token);
    setIsLoggedIn(true);
  }

  return (
    <Context.Provider value={{ login, isLoggedIn, apiClient }}>
      {children}
    </Context.Provider>
  );
}

function configAxios({
  baseURL,
  userId,
  authToken,
}: {
  baseURL: string;
  userId: number;
  authToken: string | null;
}) {
  if (!authToken) {
    console.warn("MISSING AUTH TOKEN");
  }

  const headers: Partial<AxiosHeaders> = {
    "Content-Type": "application/json",
    "X-User-Id": userId,
    Authorization: `Bearer ${authToken}`,
  };

  if (baseURL.includes("ngrok")) {
    headers["ngrok-skip-browser-warning"] = true;
  }

  return { baseURL, headers };
}
